// services/bankValidationService.js

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class BankValidationService {
  async validateBankAccount(sortCode, accountNumber) {
    try {
      const response = await fetch(`${API_BASE_URL}/bank-validation/validate-account`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({
          sort_code: sortCode,
          account_number: accountNumber
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Failed to validate bank account");
      }

      return await response.json();
    } catch (error) {
      console.error("Error validating bank account:", error);
      throw error;
    }
  }

  async getBankDetails(sortCode) {
    try {
      const response = await fetch(`${API_BASE_URL}/bank-validation/bank-details`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({
          sort_code: sortCode
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Failed to get bank details");
      }

      return await response.json();
    } catch (error) {
      console.error("Error getting bank details:", error);
      throw error;
    }
  }
}

const bankValidationService = new BankValidationService();
export default bankValidationService;